import { Component, OnInit } from '@angular/core';
import { BaseControlComponent } from '../base-control/base-control.component';
import { ContextInteractionService } from '../../services/context-interaction.service';


@Component({
    selector: 'app-report-header-image',
    templateUrl: './report-header-image.component.html',
    styleUrls: ['./report-header-image.component.scss'],
    standalone: false
})
export class ReportHeaderImageComponent extends BaseControlComponent implements OnInit {
    static componentName = 'ReportHeaderImageComponent';

    constructor(public readonly contextService: ContextInteractionService) { super(contextService); }

    ngOnInit() {
    }

}
